module.exports = __webpack_public_path__ + "icon-152x152.png";